import { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import queryString from 'query-string'
import { v4 as UUID } from 'uuid'

import { removePreviousPartialQuotes } from './helpers'
import { persistOptimiseTrackingDataInSession } from '../../utils/optimise/tracking'

import { Storage as storage, useTracking } from 'utils'

export const StartNewQuote: FC = () => {
  const location = useLocation()
  const currentQuery = queryString.parse(location.search)

  const navigate = useNavigate()
  const [quoteId] = useState(() => UUID())

  const tiktokclid = currentQuery.ttclid

  if (tiktokclid !== undefined) {
    storage.set('ttclid', `${tiktokclid}`)
  } else {
    storage.forget('ttclid')
  }

  useEffect(() => {
    storage.set('quoteId', quoteId)

    persistOptimiseTrackingDataInSession(currentQuery)
    removePreviousPartialQuotes(quoteId)

    navigate(
      {
        pathname: `/direct/${quoteId}/start`,
        search: queryString.stringify(currentQuery),
      },
      {
        state: {
          fromStartNewQuote: true,
        },
      },
    )
  })

  useTracking('Start quote', {
    referrer: currentQuery.referrer,
    ttclid: tiktokclid,
  })

  return null
}
